// extracted by mini-css-extract-plugin
module.exports = {"brandLi":"BrandEntry_brandLi__9NNgq","brandEntry":"BrandEntry_brandEntry__dyvzf","accessibilityButton":"BrandEntry_accessibilityButton__RpJ9G"};